var __jsx = React.createElement;
import React from 'react';
import { ModalContainer, ModalButton, ModalClose, ModalSecondaryHeader, ModalCopy } from 'shared/modals';
import { openZendeskWidget } from 'shared/helpers/tools';
export default (function (props) {
  return __jsx(ModalContainer, {
    isOpen: true,
    onRequestClose: props.onRequestClose
  }, __jsx(ModalSecondaryHeader, null, "OOPS!"), __jsx(ModalCopy, {
    maxWidth: 350
  }, props.message), __jsx(ModalButton, {
    onClick: function onClick() {
      openZendeskWidget();
      props.onRequestClose();
    }
  }, "Contact dutchie"), __jsx(ModalClose, {
    onClick: props.onRequestClose
  }));
});